$(document).ready(function () {
  $(".accordion_body").find("h2,h3").addClass("accordion-position-title");
  $(".accordion_body").find("p").addClass("accordion-position-content");
  $(document).on("click", ".accordion-position-title", function () {
    if ($(this).next(".accordion-position-content").is(":visible")) {
        $(this).next(".accordion-position-content").slideUp();
        $(this).removeClass("active");
    } else {
        $(this).next(".accordion-position-content").slideDown();
        $(this).addClass("active");
    }
  });
});
